import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize, distinctUntilChanged } from 'rxjs/operators';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { DataTableParams } from 'angular-datatables-all-versions';

import { StudentsForImpactService } from '../../../shared/services/students-for-impact.service';
import { IPaginationUsersImpact, IUsersImpact } from './ipagination-impact.model';
import { NgDataTableSortFormatterUtility } from '../../../shared/common/tools/ngdatatablesort-formatter.utility';


export class StudentsForImpactListDataSource implements DataSource<IUsersImpact> {

  private usersSubject = new BehaviorSubject<IUsersImpact[]>([]);
  private paginationSubject = new BehaviorSubject<IPaginationUsersImpact>({} as IPaginationUsersImpact);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private ngDataTableSortFormatterUtility = new NgDataTableSortFormatterUtility();

  public pagination = this.paginationSubject.asObservable().pipe(distinctUntilChanged());
  public loading$ = this.loadingSubject.asObservable();

  constructor(private service: StudentsForImpactService) { }

  connect(_collectionViewer: CollectionViewer): Observable<IUsersImpact[]> {
    return this.usersSubject.asObservable();
  }

  disconnect(_collectionViewer: CollectionViewer): void {
    this.usersSubject.complete();
    this.loadingSubject.complete();
    this.paginationSubject.complete();
  }

  load(search = '', offset = 1, limit = 50, sort = null) {
    console.log('load datasource', { search, offset, limit, sort });
    this.loadingSubject.next(true);

    this.service.findImpact({ offset, limit, search, impact_type_ids: '1' } as DataTableParams, true).pipe(
      catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    ).subscribe((data: IPaginationUsersImpact) => {
      if (data && data.data) {
        this.usersSubject.next(data.data);
      } else {
        this.usersSubject.next([]);
      }

      if (sort) {
        let list = data.data;

        list = list.sort((item1, item2) => {
          const sortAsc = sort['sortAsc'];
          let fieldToSort = sort['sortBy'];
          let firstVal;
          let secondVal;

          // if (sort['sortBy'] === 'category_name') {
          //   fieldToSort = 'category.name';
          // }

          firstVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item1);
          secondVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item2);

          firstVal = firstVal ? typeof firstVal === 'string' ? firstVal.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : firstVal : '';
          secondVal = secondVal ? typeof secondVal === 'string' ? secondVal.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : secondVal : '';

          return sortAsc ?
            firstVal < secondVal ? -1 : firstVal > secondVal ? 1 : 0
            :
            firstVal < secondVal ? 1 : firstVal > secondVal ? -1 : 0;
        });

        data.data = list;
      }

      this.paginationSubject.next(data);
    });
  }

  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
